import { cacheService } from './index';

// Cache TTL for Sentry session data in milliseconds (1hr)
export const SENTRY_SESSION_CACHE_TTL = 60 * 60 * 1000;
export const SENTRY_SESSION_CACHE_KEY = 'sentry:router:session';

/**
 * Invalidates the Sentry session cache
 * Call this before logout to ensure fresh session data on next navigation
 */
export function invalidateSentrySessionCache() {
  if (typeof window !== 'undefined') {
    cacheService.delete(SENTRY_SESSION_CACHE_KEY);
  }
}
